import Tools from "@/shared/services/tools";

const name = "cliente-dropdown-item";
export default {
  name,

  components: {},

  props: {
    dadosCliente: {
      type: Object,
      default: {
        razaoSocial: '',
        codigo: '',
        nomeFantasia: '',
        situacao: '',
        estadoCidade: '',
        cnpj: '',
      },
    },
  },

  mounted() {},

  updated() {},

  data() {
    return {
      textoClienteSituacao: ['A', 'D', 'I']
    };
  },

  methods: {
    aplicaMascaraCnpj(cnpjSemMascara){
      if(!cnpjSemMascara) return cnpjSemMascara
      return Tools.formatarCnpj(cnpjSemMascara)
    }
  },

  computed: {},
};
